import { GTIWebButton, Dialog, Typography, Grid, Box, Stack, FormLabel } from "@gti-controls-v2/web-core";
import useTranslation from "../../../hooks/useTranslation";
import homePageStyles from "../../../common/styles/HomePage";
import appConfig from "../../../config/app";

export const DialogoAcercaDe = (props) => {

	const { t } = useTranslation();
	const styles = homePageStyles;

	const handleClose = () => {
		props.setIsShowingDialogo(false);
	};

	return (
		<>
			<Dialog
				open={props.isShowingDialogo}
				maxWidth="xs"
				fullWidth
			>
				<Box sx={homePageStyles.modal}>
					<Grid container justify="flex-end">
						<Grid item xs={12}>
							<Box sx={styles.modalHeader}>
								<Box>
									<Box
										display="flex"
										justifyContent="center"
										alignItems="center"
									/>
								</Box>
								<Box sx={styles.modalHeaderText}>
									<Typography variant="h5" sx={styles.modalTitle}>
										{t("sistema.titulos.razonSocial")}
									</Typography>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12}>
							<Box>
								<Box sx={styles.modalConfirmation}>
									<Typography sx={styles.modalConfirmationSpan} >
										<FormLabel>
											{t("sistema.titulos.copyright")}
										</FormLabel>
										<br />
										<span>
											{t("sistema.titulos.derechosReservados")} © {new Date().getFullYear()}
										</span>
									</Typography>
									<Typography sx={styles.modalConfirmationSpan} >
										<FormLabel>
											{t("sistema.titulos.version")}
										</FormLabel>
										<br />
										<span>
											{appConfig.APP_VERSION}
										</span>
									</Typography>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12}>
							<Box sx={styles.modalButtons}>
								<Box sx={styles.spacer} />
								<Box>
									<Stack width="100%" direction="row">
										<GTIWebButton
											sx={styles.modalActionButton}
											text={t("sistema.acciones.cerrar")}
											width={"100%"}
											onClick={handleClose}
										/>
									</Stack>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Dialog>
		</>
	)
}
